export function getDarkBrandLogo(brandName?: string): string {
  if (brandName === 'Panpharma') return '/assets/medias/images/logo-panpharma.png';
  if (brandName === 'Oncoprod') return '/assets/medias/images/logo-oncoprod.png';
  if (brandName === 'SantaCruz') return '/assets/medias/images/logo-santa-cruz.png';

  return '/assets/medias/images/logo-panpharma.png';
}

export function getLightBrandLogo(brandName: string): string {
  if (brandName === 'Panpharma') return '/assets/medias/images/cart-panpharma-logo.png';
  if (brandName === 'Oncoprod') return '/assets/medias/images/cart-oncoprod-logo.png';
  if (brandName === 'SantaCruz') return '/assets/medias/images/cart-santa-cruz-logo.png';
  return '/assets/medias/images/cart-panpharma-logo.png';
}
